module.exports = __webpack_public_path__ + "57254625351e91c5c24d9a961ea733c0.svg";